import BrokenImageIcon from '@mui/icons-material/BrokenImageOutlined';
import { useEffect, useMemo, useState } from 'react';

import VodPlayer from './VodPlayer';

const DEFAULT_DELAY = 2000;

const VodClip = ({ src, image, className, loadOnOver = true, delay }) => {
    const [clipFailed, setClipFailed] = useState(false);
    const [mouseEntered, setMouseEntered] = useState(0);
    const [loadVideo, setLoadVideo] = useState(false);

    useEffect(() => {
        if (loadOnOver) {
            const timeout = setTimeout(() => setLoadVideo(mouseEntered > 0), delay || DEFAULT_DELAY);
            return () => clearTimeout(timeout);
        } else {
            setLoadVideo(false);
        }
    }, [loadOnOver, mouseEntered, delay]);

    const clipUrl = useMemo(() => src.replace('video.m3u8', 'clip.jpg'), [src]);

    const media = loadVideo ? (
        <VodPlayer src={src} autoPlay={true} />
    ) : clipFailed ? (
        <BrokenImageIcon fontSize="large" />
    ) : (
        <img src={image || clipUrl} onError={() => setClipFailed(true)} alt="Video clip" />
    );

    return (
        <div
            className={className}
            onMouseEnter={() => setMouseEntered(Date.now())}
            onMouseLeave={() => setMouseEntered(-Date.now())}
        >
            {media}
        </div>
    );
};

export default VodClip;
